export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAEElEQVR4AWP4////fRCGMwCLwg9xfm1ZGAAAAABJRU5ErkJggg=="